import React, { useEffect, useState } from "react";
import { GetOffers } from "../utils/Api";
import { toast } from "react-toastify";

export default function OfferCard() {
  const [offer, setOffer] = useState();
  useEffect(() => {
    GetOffers().then((res) => {
      if (res.status) {
        setOffer(res.data[0]);
      } else {
        toast.error(res.message);
      }
    });
  }, []);
  return (
    <div className="w-full bg-gray-200 border border-gray-300 pt-4 mt-6 rounded-2xl">
      {/* <div className="flex px-2">
                <img src="./assets/telephone.svg" />
                <h1 className="text-sm ml-2">
                  Consultation will be done on phone call
                </h1>
              </div>
              <div className="flex mt-1 px-2">
                <img src="./assets/stopwatch.svg" />
                <h1 className="text-sm ml-2">
                  Phone call will be last for 10-15 mins
                </h1>
              </div>
              <div className="flex mt-1 px-2">
                <img src="./assets/verify.svg" />
                <h1 className="text-sm ml-2">
                  Call will start any time between selected slots
                </h1>
              </div> */}
      <div dangerouslySetInnerHTML={{ __html: offer?.Para1 }}></div>
      <div
        dangerouslySetInnerHTML={{ __html: offer?.Para2 }}
        className="bg-thBlue rounded-2xl p-1 mt-3 text-white"
      ></div>
      {/* <div className="flex mt-1 bg-thBlue rounded-2xl p-1 mt-3">
                <h1 className="text-sm text-white ml-2">
                  Get 10% off on all medicines
                </h1>
              </div> */}
    </div>
  );
}
